import { action, observable, runInAction } from 'mobx';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { FacilityOrderTemplateNewPatientNewFlowCreateForm } from 'application/facility-order-new-flow/forms';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { SubCategoryService } from "application/product/services";
import { LookupService } from "common/services";
import { subCategoriesSort } from 'core/utils';
import _ from 'lodash';

class CreateFacilityOrderTemplateNewPatientNewFlowModalStore extends BaseEditViewStore {
    @observable accessor facilityOrderTemplateItems = [];
    @observable accessor disabled = false;

    constructor(rootStore, componentProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        const subCategoryService = new SubCategoryService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'create-facility-order-template-new-patient-new-flow-modal',
            Form: FacilityOrderTemplateNewPatientNewFlowCreateForm,
            actions: () => {
                return {
                    create: async (items, resource, facilityOrderId, patientId) => {
                        let facilityOrderTemplateItems = items.filter(x => x.product);
                        facilityOrderTemplateItems.forEach(i => delete i.id);

                        resource.facilityOrderTemplateMissingDocuments = resource.facilityOrderTemplateMissingDocuments && resource.facilityOrderTemplateMissingDocuments.map(i => { return { missingDocumentId: i.id } });
                        let request = {
                            ...resource,
                            facilityOrderId: facilityOrderId,
                            patientId: patientId,
                            facilityOrderTemplateItems: facilityOrderTemplateItems,
                            newFlowInsuranceStatusId: this.newFlowInsuranceStatusId,
                            isReviewed: this.isReviewed,
                            isClinicalReviewed: this.isClinicalReviewed
                        }

                        const response = await facilityOrderTemplateService.createTemplateAndItemsNewFlow(request);
                        return response.data;
                    }
                }
            },
            FormClass: FacilityOrderTemplateNewPatientNewFlowCreateForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderId = this.modalParams.data.facilityOrderId;
        this.patientId = this.modalParams.data.patientId;
        this.patient = this.modalParams.data.patient;
        this.isReviewed = this.modalParams.data.isReviewed;
        this.isClinicalReviewed = this.modalParams.data.isClinicalReviewed;
        this.newFlowInsuranceStatusId = this.modalParams.data.newFlowInsuranceStatusId;
        this.rootStore.viewStore.setNavigationOptions({
            title:""
        });

        this.subCategoryStore = new BaasicDropdownStore({}, {
            fetchFunc: async (term) => {
                const subCategorysAbrv = ["G-Tube", "Oral-Supplements", "Enteral"];
                const response = await subCategoryService.find({ searchQuery: term, rpp: 100, sort: "itemCategory.name|asc", embed: "ItemCategory"});
                
                let data =  subCategoriesSort(response.data.item.map(i=> {return {...i, name: i.name}}));
                let filteredSubCategories = _.filter(data, i => {
                    return subCategorysAbrv.some(s => i.abrv === s);
                });

                return filteredSubCategories;
            }
        });

        this.fetch([
			this.initialize()
		]);
    }

    @action
    async initialize() {
		await this.getLookups();
        this.form.clear();
	}

	@action.bound
	async getLookups() {
        const lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
        const response = await lookupService.getLookups("SubCategory");
        runInAction(() => {
            this.subCategories = response.subCategory;
        })
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;
        this.disabled = true;
        this.form.setFieldsDisabled(true);

        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(this.facilityOrderTemplateItems, resource, this.facilityOrderId, this.patientId);

            this.disabled = false;
            this.form.setFieldsDisabled(false);
            this.modalParams.close();
            this.rootStore.routerStore.goBack();

            this.rootStore.notificationStore.success('Facility order template successfully created.');
        }
        catch (err) {
            this.disabled = false;
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error('Error occured while trying to create new facility order template.');
        }
    }

}

export default CreateFacilityOrderTemplateNewPatientNewFlowModalStore;
